/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_CodeInputs */

const vi_trip_code = /** @type {(inputs: Trip_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã chuyến`)
};

/**

* @param {Trip_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_code = /** @type {((inputs?: Trip_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_code(inputs)
});